module.exports = __webpack_public_path__ + "img/blue-calendar-icon.2fe98fb2.svg";